import NangmanCenter from '@/pages/nangman-center/index.vue';

// essay 라우트는 자동 라우팅 사용 (src/pages/nangman-center/essay/[essayId].vue)
export const nangmanCenterRoutes = [
  // 실제 라우트
  {
    name: 'nangman-center-board-articleId',
    path: '/nangman-center/:board/:articleId',
    component: NangmanCenter,
    props: true,
    meta: {
      layout: 'customer',
    },
  },
  {
    name: 'nangman-center-board',
    path: '/nangman-center/:board',
    component: NangmanCenter,
    props: (route) => ({ ...route.params }),
    meta: {
      layout: 'customer',
    },
  },
];
